export const handleChange = function (event) {
	const t = event.target;
	const q = this.state.slides[this.state.position];
	const userData = { ...this.state.userData };
	const includeInScore = this.state.dimensions[q.dimension].include_in_score;

	if (!(q.dimension in userData.dimensions)) {
		userData.dimensions[q.dimension] = {
			results: {},
		};
	}
	const results = { ...userData.dimensions[q.dimension].results };

	let answers;
	if (t.type === 'radio') {
		answers = parseInt(t.id);
	} else if (t.type === 'checkbox') {
		const answerIndex = parseInt(t.id);
		answers = q.ID in results ? results[q.ID].answers : [];

		// Get exclusive answers
		let exclusiveAnswers = [];
		q.answers.forEach((answer, i) => {
			if (answer.exclusive) {
				exclusiveAnswers.push(i);
			}
		});

		if (t.checked) {
			// Checkbox is checked

			if (exclusiveAnswers.includes(answerIndex)) {
				// is an exclusive answer
				answers = [answerIndex];
			} else {
				// is not an exclusive answer

				// uncheck all exclusive answers
				exclusiveAnswers.forEach((i) => {
					if (answers.includes(i)) {
						answers.splice(answers.indexOf(i), 1);
					}
				});

				// push answer to answers array
				answers.push(answerIndex);
			}
		} else if (answers.indexOf(answerIndex) !== -1) {
			// Checkbox is not checked and unchecked box still exists in the answers array
			answers.splice(answers.indexOf(answerIndex), 1);

			// If no answer is selected set answers to false to remove it from the results list
			if (!answers.length) answers = false;
		}
	} else if (t.type === 'text') {
		answers = t.value.length ? parseInt(t.value) : false;
	}

	if (answers !== false) {
		results[q.ID] = {
			answers: answers,
		};

		if (includeInScore) {
			results[q.ID].score = this.getQuestionScore(answers);
		}
	} else {
		delete results[q.ID];
	}

	userData.dimensions[q.dimension].results = results;
	this.afterChangeHandled(userData);
};

export const handleSliderChange = function (value) {
	const q = this.state.slides[this.state.position];
	const userData = { ...this.state.userData };
	const includeInScore = this.state.dimensions[q.dimension].include_in_score;

	if (!(q.dimension in userData.dimensions)) {
		userData.dimensions[q.dimension] = {
			results: {},
		};
	}
	const results = { ...userData.dimensions[q.dimension].results };

	if (q.scale_options.type === 'percentage') {
		let i = 0;
		for (let key in q.answers) {
			const answer = q.answers[key];
			if (value >= answer.min && value <= answer.max) {
				results[q.ID] = {
					answers: value,
					answerIndex: i,
				};
				if (includeInScore) {
					results[q.ID].score = answer.value;
				}
				break;
			}
			i++;
		}
	} else if (q.scale_options.type === 'fixed') {
		const steps = 100 / (Object.keys(q.answers).length - 1);
		for (let i = 0; i < steps; i++) {
			if (value === steps * i) {
				results[q.ID] = {
					answers: i,
				};
				if (includeInScore) {
					results[q.ID].score = q.answers[i].value;
				}
				break;
			}
		}
	}

	userData.dimensions[q.dimension].results = results;
	this.afterChangeHandled(userData);
};

export const afterChangeHandled = function (userData) {
	this.setState(
		{
			userData,
		},
		this.calcUserScore,
	);
};
